<template>
    <div
        v-if="reader.$route.name === 'Last Releases'"
        class="home-page py-sm-4"
    >
        <section class="home-section">
            <div class="home-section__header">
                <h2>{{ reader.__("Last Releases") }}</h2>
            </div>
            <div class="carousel-row">
                <button
                    class="carousel-btn carousel-btn--prev"
                    @click="scrollCarousel($refs.recentTrack, -1)"
                    aria-label="Previous"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
                <div
                    class="carousel-track"
                    ref="recentTrack"
                    @wheel.prevent="onCarouselWheel($refs.recentTrack, $event)"
                >
                    <div
                        v-for="comic in lastReleases"
                        :key="comic.slug"
                        class="carousel-card"
                    >
                        <router-link :to="comic.url" class="carousel-cover">
                            <img
                                :src="comic.thumbnail_small"
                                :onerror="
                                    'this.onerror=null;this.src=\'' +
                                    comic.thumbnail +
                                    '\';'
                                "
                                :alt="comic.title"
                                :title="comic.title"
                            />
                        </router-link>
                        <div class="carousel-info">
                            <div class="carousel-rating">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="#ffc107"
                                    stroke="#ffc107"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    style="
                                        display: inline-block;
                                        vertical-align: middle;
                                    "
                                >
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                                    ></polygon>
                                </svg>
                                <span v-if="comic.rating != null">{{
                                    comic.rating
                                }}</span>
                                <span v-else>-.--</span>
                            </div>
                            <div class="carousel-title" :title="comic.title">
                                {{ comic.title }}
                            </div>
                            <div
                                v-if="comic.last_chapter"
                                class="carousel-subtitle"
                            >
                                <router-link
                                    :to="comic.last_chapter.url"
                                    class="text-success fw-bold"
                                    >{{
                                        formatChapterTitle(
                                            comic.last_chapter.full_title,
                                        )
                                    }}</router-link
                                >
                                <span class="carousel-time">{{
                                    comic.last_chapter.time
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="carousel-btn carousel-btn--next"
                    @click="scrollCarousel($refs.recentTrack, 1)"
                    aria-label="Next"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
        </section>

        <section class="home-section">
            <div class="home-section__header">
                <h2>{{ reader.__("New Titles") }}</h2>
            </div>
            <div class="carousel-row">
                <button
                    class="carousel-btn carousel-btn--prev"
                    @click="scrollCarousel($refs.newTitlesTrack, -1)"
                    aria-label="Previous"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
                <div
                    class="carousel-track"
                    ref="newTitlesTrack"
                    @wheel.prevent="
                        onCarouselWheel($refs.newTitlesTrack, $event)
                    "
                >
                    <div
                        v-for="comic in newTitles"
                        :key="comic.slug"
                        class="carousel-card"
                    >
                        <router-link :to="comic.url" class="carousel-cover">
                            <img
                                :src="comic.thumbnail_small"
                                :onerror="
                                    'this.onerror=null;this.src=\'' +
                                    comic.thumbnail +
                                    '\';'
                                "
                                :alt="comic.title"
                                :title="comic.title"
                            />
                        </router-link>
                        <div class="carousel-info">
                            <div class="carousel-rating">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="#ffc107"
                                    stroke="#ffc107"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    style="
                                        display: inline-block;
                                        vertical-align: middle;
                                    "
                                >
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                                    ></polygon>
                                </svg>
                                <span v-if="comic.rating != null">{{
                                    comic.rating
                                }}</span>
                                <span v-else>-.--</span>
                            </div>
                            <div class="carousel-title" :title="comic.title">
                                {{ comic.title }}
                            </div>
                            <div class="carousel-subtitle">
                                <span class="carousel-time"
                                    >{{ reader.__("Added") }}:
                                    {{ formatDate(comic.created_at) }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="carousel-btn carousel-btn--next"
                    @click="scrollCarousel($refs.newTitlesTrack, 1)"
                    aria-label="Next"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
        </section>

        <section class="home-section">
            <div class="home-section__header">
                <h2>{{ reader.__("Recommended") }}</h2>
            </div>
            <div class="carousel-row">
                <button
                    class="carousel-btn carousel-btn--prev"
                    @click="scrollCarousel($refs.recommendedTrack, -1)"
                    aria-label="Previous"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
                <div
                    class="carousel-track"
                    ref="recommendedTrack"
                    @wheel.prevent="
                        onCarouselWheel($refs.recommendedTrack, $event)
                    "
                >
                    <div
                        v-for="comic in recommended"
                        :key="comic.slug"
                        class="carousel-card"
                    >
                        <router-link :to="comic.url" class="carousel-cover">
                            <img
                                :src="comic.thumbnail_small"
                                :onerror="
                                    'this.onerror=null;this.src=\'' +
                                    comic.thumbnail +
                                    '\';'
                                "
                                :alt="comic.title"
                                :title="comic.title"
                            />
                        </router-link>
                        <div class="carousel-info">
                            <div class="carousel-rating">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="#ffc107"
                                    stroke="#ffc107"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    style="
                                        display: inline-block;
                                        vertical-align: middle;
                                    "
                                >
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                                    ></polygon>
                                </svg>
                                <span v-if="comic.rating != null">{{
                                    comic.rating
                                }}</span>
                                <span v-else>-.--</span>
                            </div>
                            <div class="carousel-title" :title="comic.title">
                                {{ comic.title }}
                            </div>
                            <div
                                v-if="comic.last_chapter"
                                class="carousel-subtitle"
                            >
                                <router-link
                                    :to="comic.last_chapter.url"
                                    class="text-success fw-bold"
                                >
                                    {{
                                        formatChapterTitle(
                                            comic.last_chapter.full_title,
                                        )
                                    }}
                                </router-link>
                                <span class="carousel-time">{{
                                    comic.last_chapter.time
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    class="carousel-btn carousel-btn--next"
                    @click="scrollCarousel($refs.recommendedTrack, 1)"
                    aria-label="Next"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
        </section>

        <section class="home-section">
            <div class="home-section__header">
                <h2>
                    {{
                        reader.__("Library of Manga") === "Library of Manga"
                            ? "Библиотека Манги"
                            : reader.__("Library of Manga")
                    }}
                </h2>
            </div>
            <div class="anime-grid">
                <div
                    v-for="comic in animeList"
                    :key="comic.slug"
                    class="anime-card"
                >
                    <router-link :to="comic.url" class="anime-cover">
                        <img
                            :src="comic.thumbnail_small"
                            :onerror="
                                'this.onerror=null;this.src=\'' +
                                comic.thumbnail +
                                '\';'
                            "
                            :alt="comic.title"
                            :title="comic.title"
                        />
                    </router-link>
                    <div class="anime-title" :title="comic.title">
                        {{ comic.title }}
                    </div>
                    <div class="anime-meta">
                        <div class="anime-rating">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="#ffc107"
                                stroke="#ffc107"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                style="
                                    display: inline-block;
                                    vertical-align: middle;
                                "
                            >
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                                ></polygon>
                            </svg>
                            <span v-if="comic.rating != null">{{
                                comic.rating
                            }}</span>
                            <span v-else>-.--</span>
                        </div>
                        <div v-if="comic.last_chapter" class="anime-subtitle">
                            <router-link
                                :to="comic.last_chapter.url"
                                class="text-success fw-bold"
                            >
                                {{
                                    formatChapterTitle(
                                        comic.last_chapter.full_title,
                                    )
                                }}
                            </router-link>
                            <span class="anime-time">{{
                                comic.last_chapter.time
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div v-else>
        <div class="py-sm-4">
            <h2 class="text-center pt-sm-0 pt-2 pb-sm-2">
                {{ reader.__(reader.$route.name) }}
            </h2>
            <div
                v-if="reader.$route.name === 'All Comics'"
                id="all_comics_top_html"
                class="text-center"
            ></div>
            <div class="row">
                <div
                    v-for="comic in comics"
                    :class="
                        'col-lg-6 pb-1 pt-2 border-bottom item' +
                        (comic.hidden ? ' hidden' : '')
                    "
                >
                    <div class="thumbnail float-start me-3 ms-1">
                        <router-link :to="comic.url"
                            ><img
                                :src="comic.thumbnail_small"
                                :onerror="
                                    'this.onerror=null;this.src=\'' +
                                    comic.thumbnail +
                                    '\';'
                                "
                                :alt="comic.title"
                                :title="comic.title"
                                class="rounded"
                        /></router-link>
                    </div>
                    <div
                        class="text-truncate mb-1 d-flex flex-nowrap align-items-center"
                    >
                        <h5 class="fw-bold mb-0 me-1">
                            <a
                                v-if="comic.id !== null"
                                :href="
                                    reader.BASE_URL +
                                    'admin/comics/' +
                                    comic.slug
                                "
                                target="_blank"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    style="
                                        display: inline-block;
                                        vertical-align: middle;
                                    "
                                    aria-hidden="true"
                                    title="Edit"
                                >
                                    <path
                                        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                                    ></path>
                                    <path
                                        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                                    ></path>
                                </svg>
                            </a>
                            <router-link
                                class="text-wrap filter"
                                :title="comic.title"
                                :to="comic.url"
                            >
                                {{ comic.title }}
                            </router-link>
                        </h5>
                    </div>
                    <ul class="list-inline m-1">
                        <li class="list-inline-item text-primary">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="#ffc107"
                                stroke="#ffc107"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                style="
                                    display: inline-block;
                                    vertical-align: middle;
                                "
                                aria-hidden="true"
                                title="Rating"
                            >
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                                ></polygon>
                            </svg>
                            <span v-if="comic.rating != null" title="vote">{{
                                comic.rating
                            }}</span>
                            <span v-else title="vote">-.--</span>
                        </li>
                        <li class="list-inline-item text-info">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                style="
                                    display: inline-block;
                                    vertical-align: middle;
                                "
                                aria-hidden="true"
                                title="Views"
                            >
                                <path
                                    d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                ></path>
                                <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                            <span>{{ comic.views }}</span>
                        </li>
                        <li class="list-inline-item text-info">
                            <span
                                style="margin-top: 2px"
                                class="badge badge-status p-1 text-white align-top"
                                title="Status"
                                :data-status="
                                    comic.status
                                        ? comic.status.toLowerCase()
                                        : ''
                                "
                                >{{ comic.status }}</span
                            >
                        </li>
                        <li
                            v-if="comic.last_chapter != null"
                            class="text-success"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                style="
                                    display: inline-block;
                                    vertical-align: middle;
                                "
                                aria-hidden="true"
                                title="Last chapter"
                            >
                                <path
                                    d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                                ></path>
                                <path
                                    d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                                ></path>
                            </svg>
                            <router-link
                                :to="comic.last_chapter.url"
                                class="text-success fw-bold"
                                >{{
                                    formatChapterTitle(
                                        comic.last_chapter.full_title,
                                    )
                                }}</router-link
                            >
                        </li>
                    </ul>
                    <div class="description text-pre pe-2 pe-lg-0">
                        {{ comic.description }}
                    </div>
                </div>
            </div>
            <div
                v-if="reader.$route.name === 'All Comics'"
                id="all_comics_bottom_html"
                class="text-center"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Comics",
    mounted() {
        $("body").removeClass("body-reader hide-header");

        const title =
            this.reader.SITE_NAME_FULL ||
            this.reader.SITE_NAME ||
            "MangaReader";
        $("title").html(title);
        $('meta[property="og:title"]').attr("content", title);
        $('meta[name="twitter:title"]').attr("content", title);
        $('link[rel="canonical"]').attr("href", this.reader.BASE_URL);
        $('meta[property="og:url"]').attr("content", this.reader.BASE_URL);
        this.$store.dispatch("fetchInfo", "/info");
        this.$store.dispatch("fetchComics", "/comics");
        this.comics.length && this.updateCustomHTML();
    },
    beforeRouteLeave(to, from, next) {
        if (from.path !== to.path) {
            switch (from.path) {
                case "/comics":
                    this.reader.clearCustomHTML("all_comics_top_html");
                    this.reader.clearCustomHTML("all_comics_bottom_html");
                    break;
            }
        }
        next();
    },
    updated() {
        $("#nav-search").show();
        $("#nav-filter").hide();
        this.comics.length && this.updateCustomHTML();
    },
    data() {
        return {
            reader: this.$root,
        };
    },
    methods: {
        updateCustomHTML() {
            if (this.reader.$route.name === "All Comics") {
                this.reader.updateCustomHTML("all_comics_top_html");
                this.reader.updateCustomHTML("all_comics_bottom_html");
            }
        },
        formatChapterTitle(fullTitle) {
            if (!fullTitle) return "";
            const match = fullTitle.match(/(ch\.?\s*|глава\s*)([\d.]+)/i);
            if (match) {
                return `Глава ${match[2]}`;
            }
            return fullTitle;
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            return d.toLocaleDateString("ru-RU", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        scrollCarousel(track, direction) {
            if (!track) return;
            const cardWidth =
                track.querySelector(".carousel-card")?.offsetWidth || 180;
            track.scrollBy({
                left: direction * (cardWidth + 16) * 3,
                behavior: "smooth",
            });
        },
        onCarouselWheel(track, event) {
            if (!track) return;
            track.scrollBy({ left: event.deltaY * 2, behavior: "auto" });
        },
    },
    computed: {
        ...mapGetters(["comics", "allComics", "socials"]),
        lastReleases() {
            return _.sortBy(
                this.allComics.filter((comic) => comic.last_chapter !== null),
                "last_chapter.published_on",
            ).reverse();
        },
        newTitles() {
            return _.sortBy(this.allComics, "created_at").reverse();
        },
        recommended() {
            return _.sortBy(
                this.allComics.filter((comic) => comic.recommended !== 0),
                "recommended",
            );
        },
        animeList() {
            const allowedTypes = [
                "manga",
                "manhwa",
                "manhua",
                "webtoon",
                "light-novel",
                "doujinshi",
                "one-shot",
            ];
            return _.sortBy(
                this.allComics.filter(
                    (comic) =>
                        !comic.format_slug ||
                        allowedTypes.includes(comic.format_slug),
                ),
                "title",
            );
        },
    },
};
</script>
